import React from 'react';
import classnames from 'classnames';
import { Button } from '@nerdwallet/currency/components/Button';
import styles from './continue-button.module.scss';

interface Props {
  className?: string;
  onClick?: () => void;
  type?: string;
  href?: string;
  target?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  buttonText?: string;
}

const ContinueButton = ({
  className,
  onClick,
  type = 'submit',
  href,
  target,
  isDisabled,
  isLoading,
  buttonText = 'Continue',
}: Props) => (
  <Button
    aria-label="continue button"
    primary
    block
    className={classnames(className, styles.continueButton, {
      [styles.disableButton]: isDisabled && !isLoading,
    })}
    disabled={isDisabled && !isLoading}
    onClick={isLoading ? () => {} : onClick}
    type={type}
    href={href}
    target={target}
    loading={isLoading}
  >
    {buttonText}
  </Button>
);

export default ContinueButton;
